import React from 'react';
import Button from '@components-clean/core/button';

interface ButtonsPageProps {
    isDisabled: boolean;
}

const ButtonsPage = ({ isDisabled }: ButtonsPageProps) => {
    return (
        <>
            <fieldset>
                <legend>Primary</legend>
                <div className="k-d-flex k-gap-4 k-py-2">
                    <Button data-testid="primary-button" disabled={isDisabled} primary>
                        Solid Primary
                    </Button>
                    <Button data-testid="primary-button" disabled={isDisabled} primary fillMode="outline">
                        Outline Primary
                    </Button>
                    <Button data-testid="primary-button" disabled={isDisabled} primary fillMode="flat">
                        Flat Primary
                    </Button>
                </div>
            </fieldset>

            <br />
            <fieldset>
                <legend>Secondary</legend>
                <div className="k-d-flex k-gap-4 k-py-2">
                    <Button data-testid="primary-button" alternativeStyle disabled={isDisabled} themeColor="secondary">
                        Solid Secondary
                    </Button>
                    <Button
                        data-testid="primary-button"
                        disabled={isDisabled}
                        alternativeStyle
                        fillMode="outline"
                        themeColor="secondary"
                    >
                        Outline Secondary
                    </Button>
                    <Button
                        data-testid="primary-button"
                        disabled={isDisabled}
                        alternativeStyle
                        themeColor="secondary"
                        fillMode="flat"
                    >
                        Flat Secondary
                    </Button>
                </div>
            </fieldset>
        </>
    );
};

export default ButtonsPage;
